import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { RestService } from 'src/app/services/rest.service';
import { environment } from 'src/environments/environment';
import { ExerciseTrackerDetailComponent } from './exercise-tracker-detail/exercise-tracker-detail.component';
import * as moment from 'moment';

@Component({
  selector: 'vex-exercise-tracker',
  templateUrl: './exercise-tracker.component.html',
  styleUrls: ['./exercise-tracker.component.scss']
})
export class ExerciseTrackerComponent implements OnInit {
  exercises;
  filteredExercises: any = [];
  loader: boolean = false;
  environment = environment.baseURL;
  searchCtrl: string = '';
  exercisesPlaceholder = Array(5);

  constructor(public guiService: GuiService, private restService: RestService, public translate: TranslateService, private dialog: MatDialog) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
    if (this.guiService.userLogged) {
      this.getExercises();
    } else {
      this.guiService.goTo('main/home');
    }
  }

  getExercises() {
    this.loader = true;
    this.restService.postService('node', '/user-exercise-tracker', { userId: this.guiService.userLogged.user.id }).subscribe((ris) => {
      this.mergeExercises(ris);
      this.loader = false;
    })
  }

  filterExercises() {
    if (this.searchCtrl.length < 2) {
      this.filteredExercises = this.exercises;
    } else {
      this.filteredExercises = this.exercises.filter(exercise =>
        exercise.exerciseName[this.translate.currentLang.toUpperCase()].toLowerCase().includes(this.searchCtrl.toLowerCase())
      );
    }
  }

  mergeExercises(ris) {
    const mergedExercises = [];
    if (ris.length > 0) {
      ris.forEach(exercise => {
        let foundIndex = mergedExercises.findIndex(x => x.exerciseId === exercise.exerciseId);
        if (foundIndex > -1) {
          mergedExercises[foundIndex].datas.push(
            {
              "unit": exercise.unit,
              "reps": exercise.reps,
              "sets": exercise.sets ?? null,
              "seconds": exercise.seconds,
              "registerDate": exercise.registerDate,
              "weight": exercise.weight,
              "workoutId": exercise.workoutId,
              "i18nNameWorkout": exercise.i18nNameWorkout,
              "phaseName": exercise.phaseName
            }
          )
        } else {
          let element = {
            "exerciseId": exercise.exerciseId,
            "exerciseName": exercise.exerciseName,
            "datas": [
              {
                "unit": exercise.unit,
                "reps": exercise.reps,
                "sets": exercise.sets ?? null,
                "seconds": exercise.seconds,
                "registerDate": exercise.registerDate,
                "weight": exercise.weight,
                "workoutId": exercise.workoutId,
                "i18nNameWorkout": exercise.i18nNameWorkout,
                "phaseName": exercise.phaseName
              }
            ]
          }
          mergedExercises.push(element);
        }
      });
    }

    mergedExercises.forEach(ex => {
      ex.datas.sort((a, b) => moment(b.registerDate).diff(moment(a.registerDate)));
    });

    this.exercises = mergedExercises;
    this.filteredExercises = mergedExercises;
  }

  openModalExerciseDetail(exercise: any): void {
  this.dialog.open(ExerciseTrackerDetailComponent, {
    disableClose: true,
      width: '100vw',
      height: '100vh',
      maxWidth: '100vw',
      autoFocus: false,
      panelClass: 'full-screen-dialog',
    data: { exercise }
  }).afterClosed().subscribe(dataReturned => {
    if (dataReturned != null) {
      console.log('Dati ricevuti dalla modale:', dataReturned);
    }
  });
}

}

